if($('.type-detail').length){
    $(document).ready(function(){
        $('.p-to-cart-block button[type="submit"]').text('Do košíku');
    });
    $('#extendedDescription').prepend('<h3>Parametry</h3>')
    $('.benefitBanner').after($('footer#footer .supportUs'));
}